import React from 'react'
import { cn } from '@/lib/utils'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string
  label?: string
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, label, id, ...props }, ref) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`

    return (
      <div className="space-y-2">
        {label && (
          <label htmlFor={inputId} className="block text-sm font-medium text-brand-gray">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'form-input w-full px-3 py-2 border border-brand-gray/30 rounded-monumenta',
            'bg-brand-dark-lighter text-white placeholder-brand-gray',
            'focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-brand-primary',
            'hover:border-brand-gray/50 transition-colors duration-200',
            error && 'border-error focus:ring-error focus:border-error',
            className
          )}
          {...props}
        />
        {error && (
          <p className="text-error text-sm">{error}</p>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'